import { render, staticRenderFns } from "./OffboardApplyDetail.vue?vue&type=template&id=280768ea&scoped=true&"
import script from "./OffboardApplyDetail.vue?vue&type=script&lang=js&"
export * from "./OffboardApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./OffboardApplyDetail.vue?vue&type=style&index=0&id=280768ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280768ea",
  null
  
)

export default component.exports